import {
  IconButton,
  ListItem,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import SocialRating from "./SocialRating";

const SocialCompanyListItemPeopleShort = ({ object: people, ratingKey }) => {
  const [weight, setWeight] = useState(0);
  useEffect(() => {
    if (ratingKey == "weight") {
      setWeight(people[ratingKey]);
    } else {
      setWeight(people[ratingKey]);
    }
  }, [people]);
  return (
    <Link
      to={`/people/${people.id}`}
      target="_blank"
      style={{
        textDecoration: "none",
        color: "inherit",
      }}
    >
      <ListItem
        secondaryAction={
          <Tooltip title={Math.round(weight * 100) / 100}>
            <IconButton disableFocusRipple disableRipple sx={{ p: 0 }}>
              <SocialRating value={weight} />
            </IconButton>
          </Tooltip>
        }
      >
        <ListItemButton>
          <ListItemText
            primary={people.best_name}
            primaryTypographyProps={{
              noWrap: true,
              variant: "body2",
            }}
          />
          <ListItemText
            primary={people.best_email_address}
            primaryTypographyProps={{
              noWrap: true,
              variant: "caption",
              width: "100%",
              textAlign: "end",
            }}
          />
        </ListItemButton>
      </ListItem>
    </Link>
  );
};

export default SocialCompanyListItemPeopleShort;
